import {
  HOME_SAVE_SCHEDULE_BEGIN,
  HOME_SAVE_SCHEDULE_SUCCESS,
  HOME_SAVE_SCHEDULE_FAILURE,
  HOME_SAVE_SCHEDULE_DISMISS_ERROR,
} from './constants';

import {makeDictionary} from '../../common/util'

import axios from 'axios';
import moment from 'moment';
import { enqueueSnackbar, enqueueWarning, enqueueFailedRequestWarning} from './snackActions'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveSchedule(schedule) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_SAVE_SCHEDULE_BEGIN,
    });
    console.log({w: "saveSchedule", newSchedule: schedule});
    

    const promise = new Promise((resolve, reject) => {
      axios.put("/api/schedules/",{id: schedule.id,
        seasonId:schedule.seasonId,
        description: schedule.description,
        creation: schedule.creation,
        scheduleAssignments: schedule.scheduleAssignments.filter(sa => sa.dirty)
      }).then(
        (res) => {
          console.log({res});
          dispatch({
            type: HOME_SAVE_SCHEDULE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_SAVE_SCHEDULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveScheduleError() {
  return {
    type: HOME_SAVE_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SAVE_SCHEDULE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveSchedulePending: true,
        saveScheduleError: null,
      };

    case HOME_SAVE_SCHEDULE_SUCCESS:
      // The request is success
      let updatedSchedules = makeDictionary(action.data.schedules);
      return {
        ...state,
        schedules:
        {
          ...state.schedules,
          ...updatedSchedules
        },
        saveSchedulePending: false,
        saveScheduleError: null,
      };

    case HOME_SAVE_SCHEDULE_FAILURE:
      // The request is failed
      return {
        ...state,
        saveSchedulePending: false,
        saveScheduleError: action.data.error,
      };

    case HOME_SAVE_SCHEDULE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveScheduleError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/saveSchedule.js